module.exports = __webpack_public_path__ + "img/cooperativeMedia12.a94dc70d.png";